<template>
  <div class="pending-items-list-container pending-items-list-page--glass glass-tab-page">
    <BrucdcumHeader
      :breadcrumb="['Fixed Assets', 'Pending Items List']"
      :show-back-button="true"
      :back-fallback="backFallbackRoute"
    />

    <div class="glass-tab-view glass-tab-view--flush pending-items-list-glass-shell">
      <div class="glass-tab-view__content pending-items-list-page-stack">
        <div class="pending-items-list-header-block">
          <div class="pending-items-list-header-row">
            <div class="pending-items-list-header-row__text">
              <h2 class="pending-items-list-title">Pending Items List</h2>
              <p class="pending-items-list-subtitle">
                Review fixed assets awaiting registration
              </p>
            </div>
            <div class="pending-items-list-header-actions">
              <SecondaryButton
                label="Export to CSV"
                icon="bi bi-download"
                @click="handleExportCsv"
              />
              <PrimaryButton
                label="Add a New Asset"
                icon="bi bi-plus-lg"
                @click="openNewAssetModal"
              />
            </div>
          </div>
        </div>

        <div class="pending-items-list-table-panel glass-tab-panel--nested">
          <h3 class="pending-items-list-table-heading">Pending items</h3>
          <div class="pending-items-list-table-section consultant-glass-table-section">
            <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
              <div class="consultant-glass-table-scroll-x">
                <table class="consultant-glass-table pending-items-list-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Asset Number</th>
                      <th>Account</th>
                      <th>Purchase Date</th>
                      <th>Purchase Price</th>
                      <th>Show history</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="samplePendingItems.length === 0">
                      <td colspan="7" class="consultant-glass-table-no-records pending-items-list-no-records">
                        No pending items found.
                      </td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, idx) in samplePendingItems"
                        :key="item.assetNumber + idx"
                        class="consultant-glass-table-row pending-items-list-table-row"
                        :style="{ '--pil-row-delay': `${0.04 + Math.min(idx, 14) * 0.025}s` }"
                      >
                        <td>{{ item.item }}</td>
                        <td>{{ item.assetNumber }}</td>
                        <td>{{ item.account }}</td>
                        <td>{{ item.purchaseDate }}</td>
                        <td class="pending-items-list-price-cell">{{ item.purchasePrice }}</td>
                        <td class="pending-items-list-history-cell">{{ item.showHistory }}</td>
                        <td></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition name="pending-items-list-modal-overlay">
      <div
        v-if="showNewAssetModal"
        class="pending-items-list-modal-overlay pending-items-list-modal-overlay--glass"
        @click.self="closeNewAssetModal"
      >
        <Transition name="pending-items-list-modal-panel" appear>
          <div
            v-if="showNewAssetModal"
            class="pending-items-list-modal-card pending-items-list-modal-card--glass"
            role="dialog"
            aria-modal="true"
            aria-labelledby="pending-items-new-asset-title"
            @click.stop
          >
            <div class="pending-items-list-modal-header pending-items-list-modal-header--glass">
              <h2 id="pending-items-new-asset-title" class="pending-items-list-modal-title">
                New Fixed Asset
              </h2>
              <button
                type="button"
                class="pending-items-list-modal-close-btn"
                aria-label="Close"
                title="Close"
                @click="closeNewAssetModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
            <div class="pending-items-list-modal-body pending-items-list-modal-body--glass">
              <NewFixedAsset embedded @cancel="closeNewAssetModal" @saved="closeNewAssetModal" />
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </div>
</template>

<script>
import '../styles/PendingItemsList.css';
import '../styles/pending-items-list-glass.css';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';
import NewFixedAsset from './NewFixedAsset.vue';

export default {
  name: 'PendingItemsList',
  components: {
    BrucdcumHeader,
    PrimaryButton,
    SecondaryButton,
    NewFixedAsset,
  },
  data() {
    return {
      showNewAssetModal: false,
      samplePendingItems: [
        {
          item: 'Laptop',
          assetNumber: 'A-001',
          account: 'IT Equipment',
          purchaseDate: '2023-01-15',
          purchasePrice: '$1,200.00',
          showHistory: 'View',
        },
        {
          item: 'Office Desk',
          assetNumber: 'A-002',
          account: 'Furniture',
          purchaseDate: '2023-02-10',
          purchasePrice: '$350.00',
          showHistory: 'View',
        },
        {
          item: 'Printer',
          assetNumber: 'A-003',
          account: 'Office Equipment',
          purchaseDate: '2023-03-05',
          purchasePrice: '$220.00',
          showHistory: 'View',
        },
      ],
    };
  },
  computed: {
    companyId() {
      return this.$route.params.id || this.$route.params.companyId;
    },
    backFallbackRoute() {
      const companyId = this.companyId || this.$route.params.id;
      return `/company/${companyId}/dashboard/company/fixed-assets/depreciation`;
    },
  },
  methods: {
    openNewAssetModal() {
      this.showNewAssetModal = true;
    },
    closeNewAssetModal() {
      this.showNewAssetModal = false;
    },
    handleExportCsv() {
      this.$toast?.info('Export to CSV coming soon!') || alert('Export to CSV coming soon!');
    },
  },
};
</script>
